import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { BaseModalComponent } from '@app/layout/components/modal-components/base-modal/base-modal.component';
import { Persona } from '@app/shared/interfaces/persona';
import { Speaker } from '@app/shared/interfaces/speaker';

@Component({
  selector: 'app-persona-modal',
  templateUrl: './persona-modal.component.html'
})
export class PersonaModalComponent extends BaseModalComponent implements OnInit{
  @Output() logoutEmitter = new EventEmitter();

  @Input() speaker!:Speaker;

  ngOnInit() {}
}
